import cx from 'classnames';
import { formatPhone } from '@utils/formatPhone';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import typography from '~styles/typography.scss';
import styles from './MaxGuestCountCopy.scss';

const ADDITIONAL_GUEST_TO_EXCEED_MAXIMUM_GUEST_COUNT = 1;

interface MaxGuestCountCopyProps {
  messageClassName?: string;
}

export const MaxGuestCountCopy = ({
  messageClassName,
}: MaxGuestCountCopyProps) => {
  const { restaurantDetails } = useRestaurantContext();

  const callRestaurantMessage = `For parties of ${
    restaurantDetails.maxReservationGuests +
    ADDITIONAL_GUEST_TO_EXCEED_MAXIMUM_GUEST_COUNT
  } or more guests,
  please call `;

  return (
    <>
      <h3 className={cx(styles.heading, typography.h7)}>
        Reservations for Large Parties
      </h3>
      <p
        className={cx(typography.c3, styles.maxGuestsMessage, messageClassName)}
        data-testid="max-guest-phone-message"
      >
        {callRestaurantMessage}
        <a
          href={`tel:${restaurantDetails.phone}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className={typography.t1}>
            {formatPhone(restaurantDetails.phone)}
          </span>
        </a>
      </p>
    </>
  );
};
